import CityPage from "../CityPage";

export default function Wheaton() {
  return <CityPage slug="wheaton" />;
}
